var $ = require('jquery');

$(function () {
    $('.link--locations').on('click', function (e) {
        e.preventDefault();
        $('html').toggleClass('menu-open');
        $('body').toggleClass('show-location-menu').removeClass('show-header-menu show-search');
        $('.resp-tab-item').eq(0).click();
        $('.locations').slideToggle();
        $('.header__main-menu__links, .header__sub-menu, .search').slideUp();
        $('.header__main-menu__primary-link').removeClass('open');

        $('.content-access__overlay').toggleClass('open');

        // if class open is added chagne overflow-y
        if ($('html').hasClass('menu-open')) {
            $('html').css('overflow-y', 'hidden');
            $('.header__utility-menu').addClass('scroll-hidden');
            $('.header__main-menu').addClass('scroll-hidden');
            $('.locations_global-directory--overlay').addClass('overlay-active');
            setTimeout(function () { setScrollableNav('.locations', 'locations', 'scrollable_locations'); }, 500);
        }
        else {
            locationsClosed();
        }
    });
    $('.locations__close').on('click', function (e) {
        e.preventDefault();
        $('html').removeClass('menu-open')
        $('body').removeClass('show-location-menu');
        $('.locations').slideUp();
        $('.content-access__overlay').removeClass('open');
        locationsClosed();
    });

    $('body').on('click', function () {
        $(this).parent('html').removeClass('menu-open');
        $(this).removeClass('show-location-menu');
        $('.locations').slideUp();
        $('.content-access__overlay').removeClass('open');
        locationsClosed();
    });
    $('.link--locations, .locations').on('click', function (e) {
        e.stopPropagation();
    });

    // locations menu has been closed. reset DOM elements
    function locationsClosed() {
        $('html').removeAttr('style');
        $('.header__utility-menu').removeClass('scroll-hidden');
        $('.header__main-menu').removeClass('scroll-hidden');
        $('.locations').removeClass('scrollable_locations');
        $('.locations_global-directory--overlay').removeClass('overlay-active');
        //$('.locations').css({ 'display': 'none', 'height': '', 'overflow-y': '' });
    }

    $(window).resize(function () {
        // if window is resized this will fix the desktop view if expanded from tablet (mobile) to desktop
        if ($(window).width() > 991) {
            $('.locations').removeClass('scrollable_locations');
        }

        if ($('html').hasClass('menu-open')) {
            $('html').css('overflow-y', 'hidden');
            $('.locations').removeClass('scrollable_locations');
            setTimeout(function () { setScrollableNav('.locations', 'locations', 'scrollable_locations'); }, 500);
        }
    });
});
